import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove Emergent badge
const removeBadge = () => {
  const badge = document.querySelector('a[href*="emergent.sh"]');
  if (badge) {
    const parent = badge.closest('div');
    if (parent) parent.remove();
    else badge.remove();
  }
};

// Run on load and observe for dynamic insertion
const observer = new MutationObserver(removeBadge);
observer.observe(document.body, { childList: true, subtree: true });
setTimeout(removeBadge, 100);
setTimeout(removeBadge, 500);
setTimeout(removeBadge, 1000);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
